module.exports = __webpack_public_path__ + "static/img/banner.9849714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/banner.jpg
// module id = 6uth
// module chunks = 0